import { apiGet } from "./client";

export interface HistoryScenario {
  scenario_id: number;
  scenario_name: string;
  deleted: boolean;
}

export interface HistoryRow {
  id: number;
  date: string;
  type: string;
  user_name: string;
  model_data_name?: string;
  model_data_type?: string;
  name?: string;
  scenario_name?: string;
  new_value?: string;
  details: Record<string, unknown>;
  [key: string]: unknown;
}

export function getScenarioListHistory(
  modelId: number,
): Promise<HistoryScenario[]> {
  return apiGet<HistoryScenario[]>(
    `/model/${modelId}/history/distinct_scenarios`,
  );
}

export function getScenarioHistory(
  modelId: number,
  scenarioId: number,
): Promise<HistoryRow[]> {
  return apiGet<HistoryRow[]>(
    `/model/${modelId}/scenario/${scenarioId}/history`,
  );
}
